<template>
  <div class="app" :class="`current-scene-${currentScene}`">
    <div class="stage">
      <div class="stage__padding">
        <div class="stage__inner">
          <ul class="studio-menu">
            <li class="studio-menu-boogie">
              <a href="#" @click="navigate('boogie')">Boogie-Woogie</a>
            </li>
            <li class="studio-menu-classical">
              <a href="#" @click="navigate('classical')">Classical</a>
            </li>
            <li class="studio-menu-rap">
              <a href="#" @click="navigate('rap')">Rap</a>
            </li>
            <li class="studio-menu-back">
              <a href="https://www.knowitall.org/series/studio">Back<br/>to<br/>Studio</a>
            </li>
          </ul>

          <div
            class="scene start"
            :class="{
              active: currentScene === 1,
              'active-play': currentScene === 1 && !beginButton
            }"
          >
            <div class="monitor">
              <h2>Re-Mix Studio</h2>
              <p>Be a music producer! Selects a type of music and re-mix it.</p>
            </div>
            <div class="console">
              <p class="high">High</p>
              <p class="low">Low</p>
            </div>
          </div>
          <div
            class="scene boogie"
            :class="{
              active: currentScene === 2
            }"
          >
            <div class="monitor">
              <!-- <h2>Boogie Woogie</h2> -->
              <div class="boogie-band"></div>
            </div>
            <div class="console">
              <p class="high">High</p>
              <p class="low">Low</p>
              <p class="piano-txt">Piano</p>
              <p class="bass-txt">Bass</p>
              <p class="drums-txt">Drums</p>
              <p class="guitar-txt">Guitar</p>
              <vue-slider
                class="console-slider jpiano"
                direction="btt"
                v-model="jPiano"
                @change="
                  setVolumeByName({ name: 'jPiano', volume: jPiano / 100 })
                "
              ></vue-slider>
              <vue-slider
                class="console-slider jbass"
                direction="btt"
                v-model="jBass"
                @change="
                  setVolumeByName({ name: 'jBass', volume: jBass / 100 })
                "
              ></vue-slider>
              <vue-slider
                class="console-slider jdrums"
                direction="btt"
                v-model="jDrums"
                @change="
                  setVolumeByName({ name: 'jDrums', volume: jDrums / 100 })
                "
              ></vue-slider>
              <vue-slider
                class="console-slider jguitar"
                direction="btt"
                v-model="jGuitar"
                @change="
                  setVolumeByName({ name: 'jGuitar', volume: jGuitar / 100 })
                "
              ></vue-slider>
            </div>
          </div>
          <div
            class="scene classical"
            :class="{
              active: currentScene === 3
            }"
          >
            <Orchestra ref="Orchestra"></Orchestra>
          </div>
          <div
            class="scene rap"
            :class="{
              active: currentScene === 4
            }"
          >
            <div class="monitor">
            </div>
            <div class="console">
              <p class="high">High</p>
              <p class="low">Low</p>
              <p class="voice-txt">Voice</p>
              <p class="scratch-txt">Scratching</p>
              <p class="music-txt">Music</p>
               <vue-slider
                class="console-slider rapVoice"
                direction="btt"
                v-model="rapVoice"
                @change="
                  setVolumeByName({ name: 'rapVoice', volume: rapVoice / 100 })
                "
              ></vue-slider>
               <vue-slider
                class="console-slider rapScratch"
                direction="btt"
                v-model="rapScratch"
                @change="
                  setVolumeByName({ name: 'rapScratch', volume: rapScratch / 100 })
                "
              ></vue-slider>
               <vue-slider
                class="console-slider rapMusic"
                direction="btt"
                v-model="rapMusic"
                @change="
                  setVolumeByName({ name: 'rapMusic', volume: rapMusic / 100 })
                "
              ></vue-slider>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Orchestra from "@/components/Orchestra.vue";

export default {
  name: "app",
  components: {
    Orchestra
  },
  computed: {
    ...mapState([
      "numScenes",
      "currentScene",
      "beginButton",
      "Orchestra",
      "muted",
      "actioned"
    ])
  },
  data: function() {
    return {
      isActive: true,
      jPiano: 0,
      jBass: 0,
      jDrums: 0,
      jGuitar: 0,
      rapVoice: 0,
      rapScratch: 0,
      rapMusic: 0,
    };
  },
  methods: {
    ...mapMutations(["HIDE_BEGIN_BUTTON", "RESET_TRACK_INTERVAL"]),
    ...mapActions([
      "boogieScenes",
      "classicalScenes",
      "rapScenes",
      "backStudio",
      "playAudioByName",
      "toggleAudioByName",
      "playAudioSounds",
      "toggleMute",
      "setVolumeByName"
    ]),

    navigate(direction) {
      if (direction === "boogie") {
        this.boogieScenes();
        this.playAudioByName("jPiano");
        this.playAudioByName("jBass");
        this.playAudioByName("jDrums");
        this.playAudioByName("jGuitar");
      } else if (direction === "classical") {
        this.classicalScenes();
      } else if (direction === "rap") {
        this.rapScenes();
        this.playAudioByName('rapVoice');
        this.playAudioByName('rapScratch');
        this.playAudioByName('rapMusic');
      } else if (direction === "back-studio") {
        // this.backStudio();
        // window.location.reload(true); 
      }
    }
  }
};
</script>

<style lang="scss">
body {
  background-color: #fff;
}
</style>
